import { Dispatch } from 'redux'
import { storeDispatchTypes } from "../../store/storeDispatchTypes"
import { RootState } from "../../store/rootReducer"
import { apiInstance } from "../../api/apiInstance"
import anchor from '../../../constants/anchor'

const updateMarketplaceDesctemplate = (mpDescTemplate: string) => async(
    dispatch: Dispatch,
    getState: () => RootState,
): Promise<void> => {
    const { userData } = getState()
    const params = {
        userId:  userData.smsAuth.userId,
        data: {
            mpDescTemplate: mpDescTemplate,
        },
    }
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    try {
        const { data: { status, data } } = await apiInstance.post('/sales/marketplaces/updateMarketplacesDescTemplate', params, config)
        
        if(status === 'ok') {
            dispatch({
                type: storeDispatchTypes.setMpDescTemplate,
                value: data.mpDescTemplate
            })
        }
    } catch (e) {
        console.error('set mpDescTemplate not filled, failed', e)
    }

}


export default updateMarketplaceDesctemplate
